import { CustomerAnalyticsAdspendCategory } from '@zg-rentals/ts-customer-analytics-client';

export const mapSpendTypename = (spendCategory: CustomerAnalyticsAdspendCategory): string => {
  switch (spendCategory) {
    case CustomerAnalyticsAdspendCategory.BASE:
      return 'Base';
    case CustomerAnalyticsAdspendCategory.BOOST:
      return 'Boost';
    case CustomerAnalyticsAdspendCategory.DAILY_FEED_CONNECT:
      return 'Zillow Feed Connect™';
    case CustomerAnalyticsAdspendCategory.ENHANCED:
      return 'Enhanced';
    case CustomerAnalyticsAdspendCategory.FLAT_FEE_FEED_CONNECT:
      return 'Flat Fee Feed Connect';
    case CustomerAnalyticsAdspendCategory.INTEGRATED_PAY_PER_LEASE:
      return 'Integrated Pay Per Lease';
    case CustomerAnalyticsAdspendCategory.LEASE_UP:
      return 'Lease Up';
    case CustomerAnalyticsAdspendCategory.LEGACY_PAY_PER_LEASE:
      return 'Pay Per Lease';
    case CustomerAnalyticsAdspendCategory.LISTING_SPOTLIGHT:
      return 'Listing Spotlight';
    case CustomerAnalyticsAdspendCategory.MEDIA_ADD_ON:
      return 'Extend';
    case CustomerAnalyticsAdspendCategory.MFH_FLAT_FEE:
      return 'Flat Fee';
    case CustomerAnalyticsAdspendCategory.PAY_PER_CLICK:
      return 'Pay Per Click';
    case CustomerAnalyticsAdspendCategory.PAY_PER_LEAD:
      return 'Zillow Rent Connect™';
    case CustomerAnalyticsAdspendCategory.PREMIUM:
      return 'Premium';
    case CustomerAnalyticsAdspendCategory.PREMIUM_PLUS:
      return 'Premium Plus';
    case CustomerAnalyticsAdspendCategory.SFH_FLAT_FEE_LEGACY:
      return 'Monthly Fee Legacy';
    case CustomerAnalyticsAdspendCategory.SFH_LEGACY:
      return 'Pay Per Listing';
    case CustomerAnalyticsAdspendCategory.SIGNATURE:
      return 'Signature';
    case CustomerAnalyticsAdspendCategory.WAITLIST:
      return 'Waitlist';
    default:
      return 'Unknown';
  }
};
